import { render } from "./CompetenceBlock.vue?vue&type=template&id=0b84c95c&scoped=true"
import script from "./CompetenceBlock.vue?vue&type=script&lang=js"
export * from "./CompetenceBlock.vue?vue&type=script&lang=js"

import "./CompetenceBlock.vue?vue&type=style&index=0&id=0b84c95c&scoped=true&lang=css"
import "./CompetenceBlock.vue?vue&type=style&index=1&id=0b84c95c&scoped=true&lang=css"
import "./CompetenceBlock.vue?vue&type=style&index=2&id=0b84c95c&scoped=true&lang=css"
import "./CompetenceBlock.vue?vue&type=style&index=3&id=0b84c95c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b84c95c"]])

export default __exports__